import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=2e209112&scoped=true&lang=pug&"
import script from "./ProfilePreview.vue?vue&type=script&lang=js&"
export * from "./ProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreview.vue?vue&type=style&index=0&id=2e209112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e209112",
  null
  
)

export default component.exports